import React, { Component } from 'react';
import _ from 'lodash';
import StatLegend from '../components/stat.js'
import axios from 'axios';
import StockChart from '../components/stock-chart.js';
import { db } from '../firebase';
import SymbolLink from '../components/symbol-link.js'

export default class Trending extends Component {

    constructor() {
        super();
        this.state = {
            selected_page: 'Gainers',
            symbol: "BAC",
            pages: ["Gainers", "Losers", "MostActive"],
            expanded_symbols: []
        }
        this.onPageChanged = this.onPageChanged.bind(this);
        this.onSymbolSelected = this.onSymbolSelected.bind(this);
        this.onSymbolExpandChanged = this.onSymbolExpandChanged.bind(this);
    }

    async componentDidMount() {


        this.loadList(this.state.selected_page);
    }

    async    loadList(name) {

        let symbol_list = await axios.get('https://api.iextrading.com/1.0/stock//market/list/' + name);
        this.setState({
            list: symbol_list ? symbol_list.data : [],
            symbol: symbol_list.data[0].symbol
        });
        console.log(symbol_list);
    }
    async  onPageChanged(name) {

        if (this.state.page !== name) {

            this.setState({
                selected_page: name
            });
            await this.loadList(name)
        }
    }
    onSymbolSelected(symbol) {

        this.setState({
            symbol: symbol ? symbol : 'SPY'
        })
    }
    onSymbolExpandChanged(symbol) {

        let expanded_symbols = this.state.expanded_symbols ? [...this.state.expanded_symbols] : [];
        let item_index = expanded_symbols.indexOf(symbol);
        if (item_index >= 0) {

            expanded_symbols.splice(expanded_symbols.indexOf(symbol), 1);
        }
        else {

            expanded_symbols.push(symbol);
        }
        this.setState({
            expanded_symbols: expanded_symbols
        })
    }

    render() {

        // /https://www.barchart.com/stocks/most-active/trading-liquidity
        let pages = this.state.pages;
        let active_page = this.state.selected_page;
        let onPageChanged = this.onPageChanged;
        let onSymbolSelected = this.onSymbolSelected;
        let onSymbolExpandChanged = this.onSymbolExpandChanged;
        let selectedSymbol = this.state.symbol;
        let expanded_symbols = this.state.expanded_symbols ? this.state.expanded_symbols : [];

        return (
            <div className="ss-container-stacked ss-page">
                <nav className="navbar is-transparent ss-fixed-row" style={{ height: "72px", borderBottom: "1px solid #dbdbdb" }}>
                    <div class="navbar-brand">
                        <a class="navbar-item">
                            <img src="https://www.iconexperience.com/_img/g_collection_png/standard/512x512/spreadsheet.png" />
                        </a>
                    </div>
                    <div className="navbar-start">
                        <div className="navbar-item">
                            <div>
                                <p className="title is-4">Trending</p>
                            </div>
                        </div>
                    </div>
                </nav>
                <div className="ss-fixed-row">
                    <div className="tabs is-medium is-left">
                        <ul>
                            {pages.map(function (item) {
                                return <li className={(active_page && active_page === item) ? 'is-active' : ''}>
                                    <a onClick={(e) => onPageChanged(item)}>{item}</a>
                                </li>
                            })}
                        </ul>
                    </div>
                </div>
                <section class="section ss-flex-row" style={{ backgroundColor: "hsl(0, 0%, 96%)" }}>
                    <div className=" ss-fixed-row" >
                        {<StockChart symbol={this.state.symbol} />}
                        <hr style={{ marginTop: "0", backgroundColor: "transparent" }} />
                    </div>
                    <div className="card">
                        <table className="table table is-narrow is-fullwidth table is-hoverable ">
                            <thead>
                                <th>Symbol</th>
                                <th>Name</th>
                                <th><span className="is-pulled-left">Sector</span></th>
                                <th><span className="is-pulled-right">Change %</span></th>
                                <th><span className="is-pulled-right">52 Week Range </span></th>
                            </thead>
                            <tbody>
                                {this.state.list && this.state.list.map(function (pos_item, i) {

                                    let is_expanded = expanded_symbols.indexOf(pos_item.symbol) >= 0;
                                    return <React.Fragment>
                                        <tr onClick={() => onSymbolSelected(pos_item.symbol)} class={selectedSymbol == pos_item.symbol && "is-selected"}>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <a class="button is-white is-small" style={{ backgroundColor: "transparent" }} onClick={() => onSymbolExpandChanged(pos_item.symbol)}>
                                                    <span class="icon is-small">
                                                        <i class={is_expanded ? "fa fa-minus" : "fa fa-plus"} aria-hidden="true"></i>
                                                    </span>
                                                </a>
                                                <SymbolLink symbol={pos_item.symbol} />
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <span className="is-pulled-left">{pos_item.companyName}</span>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <span className="is-pulled-left">{pos_item.sector}</span>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <span className="is-pulled-right">{(pos_item.changePercent * 100).toFixed(2)}</span>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }} >
                                                <progress title={pos_item.week52Low ? (pos_item.week52Low + " - " + pos_item.week52hHigh) : '-'} class="progress is-info" value={(pos_item.latestPrice * 100) / pos_item.week52High} max="100"></progress>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                })}
                            </tbody>
                        </table>
                    </div>
                </section >
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/containers/trending.js